/* ==========================================================
   ENTERPRISE BUNDLE PRODUCT SWITCH
   (Keeps Master Bundle Page Intact)
========================================================== */

/* ==============================
   UTIL: FORMAT MONEY
============================== */

function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}


/* ==============================
   MAIN PRODUCT SWITCH
============================== */

async function switchProduct(handle) {

  try {

    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();

    const variant = product.variants[0];

    updateTitle(product);
    updatePrice(variant);
    updateSaleBadge(variant);
    updateSKU(variant);
    updateVariantForms(variant);
    updateGallery(product);
    updateDescription(product);
    updateBreadcrumb(product);
    updateQuoteButton(product);

  } catch (err) {
    console.error("Product switch failed:", err);
  }
}


/* ==============================
   TITLE
============================== */

function updateTitle(product) {
  const title = document.querySelector(".product-title");
  if (title) title.textContent = product.title;
}


/* ==============================
   PRICE + COMPARE PRICE
============================== */

function updatePrice(variant) {

  const currentEl = document.querySelector(".price__current");
  const wasEl = document.querySelector(".price__was");
  const wrapper = document.querySelector(".price");

  if (!currentEl) return;

  currentEl.textContent = formatMoney(variant.price);

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {

    if (wasEl) {
      wasEl.textContent = formatMoney(variant.compare_at_price);
      wasEl.style.display = "";
    }

    wrapper?.classList.add("price--on-sale");

  } else {

    if (wasEl) {
      wasEl.style.display = "none";
      wasEl.textContent = "";
    }

    wrapper?.classList.remove("price--on-sale");
  }
}


/* ==============================
   SALE BADGE
============================== */

function updateSaleBadge(variant) {

  const badge = document.querySelector(".product-label--sale");
  if (!badge) return;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {

    const percent = Math.round(
      ((variant.compare_at_price - variant.price) /
        variant.compare_at_price) * 100
    );

    badge.textContent = `${percent}% off`;
    badge.style.display = "";

  } else {
    badge.style.display = "none";
  }
}


/* ==============================
   SKU
============================== */

function updateSKU(variant) {
  const sku = document.querySelector(".product-sku__value");
  if (sku) sku.textContent = variant.sku || "";
}


/* ==============================
   UPDATE FORMS (ATC + INSTALLMENTS)
============================== */

function updateVariantForms(variant) {

  document.querySelectorAll('input[name="id"]').forEach(input => {
    input.value = variant.id;
  });

  const pickup = document.querySelector("pickup-availability");
  if (pickup) pickup.setAttribute("data-variant-id", variant.id);
}


/* ==============================
   DESCRIPTION
============================== */

function updateDescription(product) {

  const container = document.querySelector(".product-description");
  if (container) {
    container.innerHTML = product.description;
  }
}


/* ==============================
   GALLERY (Stable Rebuild)
============================== */

function updateGallery(product) {

  const viewer = document.querySelector("#gallery-viewer");
  const thumbs = document.querySelector(".media-thumbs");

  if (!viewer) return;

  viewer.innerHTML = "";
  if (thumbs) thumbs.innerHTML = "";

  product.images.forEach((img, index) => {

    const li = document.createElement("li");
    li.className =
      "media-viewer__item" +
      (index === 0 ? " is-current-variant" : "");

    li.innerHTML = `
      <div class="media relative" style="padding-top:100%">
        <img src="${img}" class="product-image img-fit img-fit--contain w-full">
      </div>
    `;

    viewer.appendChild(li);

    if (thumbs) {

      const thumb = document.createElement("li");
      thumb.className = "media-thumbs__item";

      thumb.innerHTML = `
        <button class="media-thumbs__btn media relative w-full">
          <img src="${img}" class="img-fit img-fit--contain w-full">
        </button>
      `;

      thumbs.appendChild(thumb);
    }
  });

  // Force Shopify media component rebind
  const mediaGallery = document.querySelector("media-gallery");
  if (mediaGallery) {
    const parent = mediaGallery.parentNode;
    const clone = mediaGallery.cloneNode(true);
    parent.replaceChild(clone, mediaGallery);
  }

  window.dispatchEvent(new Event("resize"));
}


/* ==============================
   BREADCRUMB
============================== */

function updateBreadcrumb(product) {

  const link = document.querySelector(
    '.breadcrumbs-list__link[aria-current="page"]'
  );

  if (!link) return;

  link.textContent = product.title;
  link.href = `/products/${product.handle}`;
}


/* ==============================
   QUOTE BUTTON
============================== */

function updateQuoteButton(product) {

  const btn = document.getElementById("get-quote-btn");
  if (!btn) return;

  const title = encodeURIComponent(product.title);
  const image = encodeURIComponent(
    product.featured_image || product.images[0]
  );

  btn.href =
    `https://ecommercebusinessprime.com/pages/get-a-quote?product=${title}&image=${image}`;
}


/* ==========================================================
   PACK SIZE LOGIC (4 / 2 / 1)
========================================================== */

function initializePackUI() {

  const sizeButtons = document.querySelectorAll('.pack-size-btn');
  const productButtons = document.querySelectorAll('.pack-button');

  if (!sizeButtons.length) return;

  const defaultPack = "4";

  sizeButtons.forEach(btn => {
    btn.classList.toggle('active', btn.dataset.pack === defaultPack);
  });

  productButtons.forEach(btn => {
    btn.style.display =
      btn.dataset.pack === defaultPack ? 'inline-flex' : 'none';
  });

  const first = document.querySelector(
    `.pack-button[data-pack="${defaultPack}"]`
  );

  if (first) {
    first.classList.add('active');
    switchProduct(first.dataset.productHandle);
  }

  sizeButtons.forEach(btn => {

    btn.addEventListener('click', () => {

      const selected = btn.dataset.pack;

      sizeButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      productButtons.forEach(p => {
        p.style.display =
          p.dataset.pack === selected ? 'inline-flex' : 'none';
        p.classList.remove('active');
      });

      const firstVisible = document.querySelector(
        `.pack-button[data-pack="${selected}"]`
      );

      if (firstVisible) {
        firstVisible.classList.add('active');
        switchProduct(firstVisible.dataset.productHandle);
      }

    });

  });

}


/* ==========================================================
   PRODUCT BUTTON CLICK
========================================================== */

document.addEventListener("click", (e) => {

  const btn = e.target.closest(".pack-button");
  if (!btn) return;

  e.preventDefault();

  document.querySelectorAll(".pack-button")
    .forEach(b => b.classList.remove("active"));

  btn.classList.add("active");

  switchProduct(btn.dataset.productHandle);
});


/* ==============================
   INIT
============================== */

document.addEventListener("DOMContentLoaded", () => {
  initializePackUI();
});
